import { render, staticRenderFns } from "./AddEditOrderModal.vue?vue&type=template&id=19f0a0d1&scoped=true"
import script from "./AddEditOrderModal.vue?vue&type=script&lang=js"
export * from "./AddEditOrderModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditOrderModal.vue?vue&type=style&index=0&id=19f0a0d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f0a0d1",
  null
  
)

export default component.exports